export const FETCH_VALIDATE_USER_NAME_REQUEST = 'FETCH_VALIDATE_USER_NAME_REQUEST'
export const FETCH_VALIDATE_USER_NAME_SUCCESS = 'FETCH_VALIDATE_USER_NAME_SUCCESS'
export const FETCH_VALIDATE_USER_NAME_FALUIRE = 'FETCH_VALIDATE_USER_NAME_FALUIRE'
export const FETCH_CLEAR_VALIDATE_USER_NAME_MESSAGE = 'FETCH_CLEAR_VALIDATE_USER_NAME_MESSAGE'
